/** Reads a File as base64 (without the `data:...;base64,` prefix) for the
 * JSON+base64 upload endpoints (logo, background image, match report, …). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string).split(',')[1] ?? '');
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
